import { getInitialState, getPath } from "../../utils";

const initialState = {
  telecallerLeads: [],
  rejectionReasons: [],
  callStatuses: [],
  prevPage: -1,
  nextPage: -1,
  activeLeadEngagement: {},
  currentPage: 1,
  activeFilter: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_TELECALLER_LEADS":
      return setTelecallerLeads(state, action);
    case "TELECALLER_LEADS_SET_REASONS":
      return setReasons(state, action);
    case "SET_ACTIVE_LEAD_ENGAGEMENT":
      return setActiveLeadEngagement(state, action);
    case "SET_CURRENT_PAGE_TELECALLERS_LEADS":
      return setCurrentPageTelecallersLeads(state, action);
    case "RESET_STATE_TELECALLER_LEADS":
      return resetStateTelecallerLeads(state, action);
    case "SET_ACTIVE_FILTER_TELECALLER_LEADS":
      return setActiveFilterTelecallerLeads(state, action);
    default:
      return state;
  }
}

const setCurrentPageTelecallersLeads = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const setReasons = (state, action) => {
  return {
    ...state,
    rejectionReasons: getPath(action.payload, "nonInterestedReasons", []),
    callStatuses: getPath(action.payload, "callStatus", []),
  };
};

const setTelecallerLeads = (state, action) => {
  return {
    ...state,
    telecallerLeads: getPath(action.payload, "leadsResponse", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
  };
};

const resetStateTelecallerLeads = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setActiveLeadEngagement = (state, action) => {
  return {
    ...state,
    activeLeadEngagement: action.payload,
  };
};

const setActiveFilterTelecallerLeads = (state, action) => {
  return {
    ...state,
    activeFilter: action.payload,
  };
};
